export default __webpack_public_path__ + "static/howlt-sans-reg-fffbe8bc5721e3167708aae0ab22671b.eot";